import { render, staticRenderFns } from "./CaFooter.vue?vue&type=template&id=5e93e9d9&"
import script from "./CaFooter.vue?vue&type=script&lang=js&"
export * from "./CaFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports